import { serverMessage } from "../../../utils/serverMessage";
import type { DownloadParts } from "./Descargas/downloads.types";
import {
  downloadsLockRefusal,
  takeDownloadsLock,
} from "./Descargas/downloadsLock";
import type { HeldLock } from "./Descargas/downloadsLock";
import { runDownloads } from "./Descargas/downloadsRunner";
import type { DownloadRowState } from "./Descargas/rowResult";

export type PlatformDownload = { ok: true } | { ok: false; error: string };

const EVERY_PART: DownloadParts = {
  od: true,
  quiz: true,
  quizVideo: true,
  odSummary: false,
};
const FAILED = "No se pudo descargar la versión de plataforma.";

// SCRUM-1532: what a person downloads before redoing their changes on the
// platform's version of a course. The Descargas tab's own run of that one
// course, under its lock; never rejects.
export async function downloadPlatformVersion(
  courseId: number,
): Promise<PlatformDownload> {
  let lock: HeldLock;
  try {
    // One course finishes on its own even if the lease is lost meanwhile.
    lock = await takeDownloadsLock([courseId], () => undefined);
  } catch (error) {
    return {
      ok: false,
      error:
        downloadsLockRefusal(error) ??
        serverMessage(error, "No se pudo tomar el turno de la descarga."),
    };
  }

  let last: DownloadRowState | null = null;
  try {
    await runDownloads({
      courses: [{ courseId }],
      parts: EVERY_PART,
      onUpdate: (_courseId, state) => {
        last = state;
      },
      shouldStop: () => false,
    });
  } catch {
    return { ok: false, error: FAILED };
  } finally {
    lock.release();
  }
  const final = last as DownloadRowState | null;
  if (final?.kind === "done") return { ok: true };
  return { ok: false, error: final?.kind === "error" ? final.message : FAILED };
}
